import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import styles from './LocalShipmentDialog.styles';
import { ILayoutShippingDialog } from './LocalShipmentDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import { usePODispatch } from 'components/PurchaseOrders/PurchaseOrders.context';
import FormView from 'components/FormView';
import SummaryTable from 'components/common/SummaryTable';
import SummaryTableSchema from './LocalShipmentDialog.summaryable.schema';
import { LocalShipmentLeftPanelFrom, LocalShipmentRightPanelFrom } from './LocalShipmentDialog.form';
import ToggleButton from 'components/common/ToggleButton';

const LocalShipmentDialog = (props: ILayoutShippingDialog) => {
  const { open, onClose, onOk, classes, initialValues, valuesLocalShipmentLeftPanelFrom, valuesLocalShipmentRightPanelFrom } = props;
  const contextDispatch = usePODispatch();

  const [CloseShipment, setCloseShipment] = useState(true);

  const confirmationActions = (): IActionItem[] => {
    const { Weight, CubicSize, Cartons, Pallets, EnteredDate, DespatchedDate, EstimatedArrivalDate } = valuesLocalShipmentRightPanelFrom || {};
    const rightFields = {
      Weight, CubicSize, Cartons, Pallets, EnteredDate, DespatchedDate, EstimatedArrivalDate
    };

    return [
      {
        title: 'Ok',
        isDefault: true,
        listener: () => {
          if (onOk) {
            onOk({
              ...valuesLocalShipmentLeftPanelFrom,
              ...rightFields,
              CloseShipment,
            });
          }
        }
      },
      {
        title: 'Cancel',
        listener: () => {
          contextDispatch({ setProcessPurchaseOrderDetails: { Action: null, UserId: null } });
          onClose();
        }
      }
    ];
  };

  function getModalContent(): JSX.Element {

    return (
      <div>
        <div className={classes.formContainer}>
          <div className={classes.leftContainer}>
            <FormView
              isModal={true}
              isLoading={false}
              formName={'LocalShipmentLeftPanelFrom'}
              schema={LocalShipmentLeftPanelFrom}
              includeTabsHeight={true}
              initialValues={initialValues}
              valuesSchema={{}}
              operationMode={'EDIT'}
              fieldExtensions={{}}
            />
          </div>
          <div className={classes.rightContainer}>
            <FormView
              isModal={true}
              isLoading={false}
              formName={'LocalShipmentRightPanelFrom'}
              schema={LocalShipmentRightPanelFrom}
              includeTabsHeight={true}
              initialValues={initialValues}
              valuesSchema={{}}
              operationMode={'EDIT'}
              fieldExtensions={{}}
              summaryTableRenderer={
                (() => <SummaryTable
                  loading={false}
                  selectedlocalShipment={initialValues}
                  data={SummaryTableSchema}
                />)}
            />
          </div>
        </div>
        <div className={classes.toggleContainer}>
          <ToggleButton
            inputRef={null}
            checked={CloseShipment}
            disabled={false}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setCloseShipment(e.target.checked);
            }}
            label={'Close shipment'}
            value={'CloseShipment'}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      <FormViewModal
        open={open}
        dialogStyles={{
          width: '900px',
          minHeight: 700,
          maxHeight: 700,
          height: '100%'
        }}
        loading={false}
        title={'Local Shipment Entry'}
        dialogActionsButtons={true}
        dialogActionsShadow={false}
        modalContent={getModalContent()}
        actions={confirmationActions()}
      />
    </>
  );
};

export default withStyles(styles, { index: 1 })(LocalShipmentDialog);
